import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import { NOTICE_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, noticeValidationSchema } from '../../utils/formConfig';

const EditNotice: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={noticeValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={NOTICE_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditNotice;
